import { ErrorPageComponent } from './components/front-office/error-page/error-page.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PageNotFoundComponent } from 'src/app/core/components/page-not-found/page-not-found.component';
import { AuthGuard } from 'src/app/core/guards/auth.guard';
import { DifensoreCivicoComponent } from 'src/app/components/front-office/difensore-civico/difensore-civico.component';
import { GaranteMinoriComponent } from 'src/app/components/front-office/garante-minori/garante-minori.component';
import { GaranteDetenutiComponent } from 'src/app/components/front-office/garante-detenuti/garante-detenuti.component';
import { RicercaPraticaComponent } from 'src/app/components/back-office/ricerca-pratica/ricerca-pratica.component';
import { RicercaUtenteComponent } from 'src/app/components/back-office/ricerca-utente/ricerca-utente.component';
import { RicercaUtenteDetailComponent } from './components/back-office/ricerca-utente-detail/ricerca-utente-detail.component';
import { NuovoUtenteComponent } from './components/back-office/nuovo-utente/nuovo-utente.component';
import { MainFrontOfficeComponent } from './components/front-office/main-front-office/main-front-office.component';
import { BackOfficeLandingPageComponent } from './components/back-office/back-office-landing-page/back-office-landing-page.component';
import { BackOfficeGuard } from './core/guards/back-office.auth.guard';


const routes: Routes = [
    { 
        path: 'public',
        loadChildren : () => import('./components/front-office/front-office.module').then( m => m.FrontOfficeModule)
    },
   /* { 
        path: 'backoffice',
        canActivate : [BackOfficeGuard],
        loadChildren : () => import('./components/back-office/back-office.module').then( m => m.BackOfficeModule)
    },*/
    { path: 'error/:status', component : ErrorPageComponent},
    { path: '**', component: PageNotFoundComponent }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { scrollPositionRestoration:'top'})],
    exports: [RouterModule]
})
export class AppRoutingModule { }
